import * as React from 'react';
import {FilterOverlayContext} from "../../context/FilterOverlayContext";
import {useContext, useEffect, useMemo, useRef} from "react";
import MapSidePanel, {getLengthOfFilters} from "./MapSidePanel";
import "./overlayfilter.scss";
import Button from "../Input/Button";
import {FilterContext} from "../../context/FilterContext";
import {useTranslation} from "react-i18next";
import VyberServisuHeaderForm from "../../pages/MapaServisu/VyberServisuHeaderForm";

const OverlayFilter = () => {

    const overlayFilterPanelRef = useRef<HTMLDivElement>(null);
    const { setIsOverlayFilterOpen, isOverlayFilterOpen } = useContext(FilterOverlayContext);
    const { filterParams , updateVozidloParams} = useContext(FilterContext);

    const { t } = useTranslation('translation', { keyPrefix: 'map.sidebar.filters' });

    useEffect(() => {
       if(isOverlayFilterOpen){
           document.documentElement.style.overflow = "hidden";
       }
       else {
           document.documentElement.style.overflow = "unset";
       }

        return () => {
            document.documentElement.style.overflow = "unset";
        }
    }, [isOverlayFilterOpen]);

    const calculateLength : any = useMemo(() => {
        return getLengthOfFilters(filterParams);
    }, [filterParams?.openingHours, filterParams?.filter, filterParams?.payment, filterParams?.lang, filterParams?.services, filterParams?.branches]);


    return (
        <div ref={overlayFilterPanelRef} className={"filter-overlay-panel"}>
            <div className={"filter-overlay-panel__wrapper"}>
                <div className={"filter-overlay-panel__wrapper__close-filter-wrapper"}>
                    <Button className={"dark"} type={"button"} onClick={() => setIsOverlayFilterOpen(false)}>{t('return')}</Button>
                    <Button className={"dark"} type={"button"} onClick={() => {
                        if(!calculateLength || typeof calculateLength !== "number"){
                            return;
                        }
                        updateVozidloParams({ openingHours: null, filter: null, payment: null, lang: null, services: null, branches: null  })
                    }}><span>{t('reset_short')} (<span className={"semibold green-discount"}>{calculateLength}</span>)</span></Button>
                </div>
                <MapSidePanel hasLocation={true} />
            </div>
        </div>
    )
}
export default OverlayFilter;